import { render, staticRenderFns } from "./PointRuleForm.vue?vue&type=template&id=40ada4bb&"
import script from "./PointRuleForm.vue?vue&type=script&lang=js&"
export * from "./PointRuleForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports